import { Redirect } from "react-router-dom";

//Authentication pages
import Login from "src/pages/Authentication/Login";
import Logout from "src/pages/Authentication/Logout";
import Register from "src/pages/Authentication/Register";
import userProfile from "src/pages/Authentication/user-profile";
import Home from "../pages/dynamicPages/home";
import HomeModal from "../pages/dynamicPages/homeModal";
import Agent from "../pages/dynamicPages/agent";
import AboutUs from "../pages/dynamicPages/aboutUs";
import NewsList from "../pages/news/NewsList";
import News from "../pages/news/News";
import PropertiesList from "../pages/properties/PropertiesList";
import Properties from "../pages/properties/Properties";
import Banners from "../pages/banners/Banners";
import Config from "../pages/config/config";
import ContactsList from "../pages/contacts/Contacts";
import SubscriptorsList from "../pages/subscriptors/Subscriptors";
import Brokers from "../pages/brokers/Brokers";
import Authorize from "../pages/Authorize";
import Business from "../pages/business/Business";
import PropertiesGrowthList from "../pages/growth/PropertiesGrowthList";
import Navbar from "../pages/navbar/Navbar";
import PropertyLabels from "../pages/propertyLabels/PropertyLabels";
import Contact from "../pages/contact/Contact";
import Ratings from "../pages/ratings/Ratings";
import FooterConfig from "../pages/footer/Footer";

interface RouteProps {
  path: string;
  component: any;
  exact?: boolean;
}

const userRoutes: Array<RouteProps> = [
  //User Profile
  { path: "/profile", component: userProfile },

  //dashboard
  { path: "/home", component: Home },
  { path: "/home-modal", component: HomeModal },
  { path: "/banners", component: Banners },
  { path: "/agent", component: Agent },
  { path: "/aboutUs", component: AboutUs },
  { path: "/config", component: Config },
  { path: "/navbar", component: Navbar },
  { path: "/footer", component: FooterConfig },
  { path: "/contact", component: Contact },

  //news
  { path: "/news/:id", component: News },
  { path: "/news", component: NewsList },

  { path: "/propuesta", component: Brokers },
  { path: "/empresa", component: Business },

  { path: "/contacts", component: ContactsList },
  { path: "/subscriptors", component: SubscriptorsList },

  //properties
  { path: "/properties/:id", component: Properties },
  { path: "/properties", component: PropertiesList },
  { path: "/property-labels", component: PropertyLabels },

  //growth
  { path: "/growth-config", component: PropertiesGrowthList },
  { path: "/properties-config", component: PropertiesList },

  { path: "/authorize", component: Authorize },

  { path: "/ratings", component: Ratings },

  // this route should be at the end of all other routes
  { path: "/", exact: true, component: () => <Redirect to="/properties" /> },
];

const authRoutes: Array<RouteProps> = [
  //Authentication pages
  { path: "/login", component: Login },
  { path: "/logout", component: Logout },
  { path: "/register", component: Register },
];

export { userRoutes, authRoutes };
